<template>
  <div class="group-setup">
    <BoardMeetingView v-if="activity === 'BOARD_MEETING'"></BoardMeetingView>
    <MonthlyMeetingView
      v-if="activity === 'MONTHLY_MEETING'"
    ></MonthlyMeetingView>
    <MonthlyMembershipsView
      v-if="activity === 'MONTHLY_MEMBERSHIP'"
    ></MonthlyMembershipsView>
    <PublishNewLatterView
      v-if="activity === 'PUBLISH_NEWS_LETTER'"
    ></PublishNewLatterView>
    <FinancialStatementView
      v-if="activity === 'FINANCIAL_STATEMENT'"
    ></FinancialStatementView>
    <FacebookView v-if="activity === 'INITIATING_FACEBOOK'"></FacebookView>
    <WebsiteView v-if="activity === 'INITIATING_WEBSITE'"></WebsiteView>
    <TrainingsView v-if="activity === 'TRAINING'"></TrainingsView>
    <ExtensionNewLionsClubView
      v-if="activity === 'EXTENSION_NEW_LIONS_CLUB'"
    ></ExtensionNewLionsClubView>
    <ExtensionNewLeoClubView
      v-if="activity === 'EXTENSION_NEW_LEO_CLUB'"
    ></ExtensionNewLeoClubView>
    <PresidentExcellenceAwardsView
      v-if="activity === 'APPLY_PRESIDENT_EXCELLENCE_AWARD'"
    ></PresidentExcellenceAwardsView>
    <LeadersInClubVicinitiesView
      v-if="activity === 'LEADER_LIST_CLUB_VICINITY'"
    ></LeadersInClubVicinitiesView>
    <NewClubOfficerWorkshopsView
      v-if="activity === 'PARTICIPATION_NEW_CLUB_OFFICERS_WORKSHOP'"
    ></NewClubOfficerWorkshopsView>
    <MafContributionView
      v-if="activity === 'MAF_CONTRIBUTION'"
    ></MafContributionView>
    <MjfContributionView
      v-if="activity === 'MJF_CONTRIBUTION'"
    ></MjfContributionView>
    <CabinetInstallationCeremonyView
      v-if="activity === 'PARTICIPATION_CABINET_INSTALLATION_CEREMONY'"
    ></CabinetInstallationCeremonyView>
    <AppointmentBoardClubAuditorView
      v-if="activity === 'APPOINTMENT_AUDITOR'"
    ></AppointmentBoardClubAuditorView>
    <HonoringPastPresidentView
      v-if="activity === 'HONORING_PAST_PRESIDENT'"
    ></HonoringPastPresidentView>

    <HandingOverClubRecordView
      v-if="activity === 'HANDING_OVER_CLUB_DETAILS'"
    ></HandingOverClubRecordView>

    <DistrictDueView v-if="activity === 'DISTRICT_DUES'"></DistrictDueView>
    <PaymentDistrictDirectoryView
      v-if="activity === 'PAYMENT_DISTRICT_DIRECTORY'"
    ></PaymentDistrictDirectoryView>

    <PublishingClubDirectoryView
      v-if="activity === 'PUBLISHING_CLUB_DIRECTOR'"
    ></PublishingClubDirectoryView>

    <RecognitionLionLadyView
      v-if="activity === 'RECOGNITION_LION_LADIES'"
    ></RecognitionLionLadyView>

    <LadiesGetTogetherView
      v-else-if="activity === 'LADIES_GET_TOGETHER'"
    ></LadiesGetTogetherView>
    <FirstZonalAdvisoryView
      v-else-if="activity === 'FIRST_ZONAL_ADVISORIES'"
    ></FirstZonalAdvisoryView>

    <RegionActionMeetingView
      v-else-if="activity === 'REGION_ACTION_MEETING'"
    ></RegionActionMeetingView>

    <AuditedAccountView
      v-else-if="activity === 'AUDITED_ACCOUNTS'"
    ></AuditedAccountView>

    <GetDateCharterView
      v-else-if="activity === 'GET_DATE_CHARTERS'"
    ></GetDateCharterView>

    <InternationalDueView
      v-else-if="activity === 'INTERNATIONAL_DUES'"
    ></InternationalDueView>

    <DistrictGetTogetherView
      v-else-if="activity === 'DISTRICT_GET_TOGETHER'"
    ></DistrictGetTogetherView>

    <ZoneChairpersonVisitView
      v-else-if="activity === 'ZONE_CHAIRPERSON_VISIT'"
    ></ZoneChairpersonVisitView>

    <ReportCepWorkshopView
      v-else-if="activity === 'REPORT_CEP_WORKSHOP'"
    ></ReportCepWorkshopView>

    <RegionChairpersonVisitView
      v-else-if="activity === 'REGION_CHAIRPERSON_VISIT'"
    ></RegionChairpersonVisitView>

    <MemberSponsorNightView
      v-else-if="activity === 'MEMBER_SPONSOR_NIGHT'"
    ></MemberSponsorNightView>

    <SecondZonalAdvisoryView
      v-else-if="activity === 'SECOND_ZONAL_ADVISORIES'"
    ></SecondZonalAdvisoryView>
    <ThirdZonalAdvisoryView
      v-else-if="activity === 'THIRD_ZONAL_ADVISORIES'"
    ></ThirdZonalAdvisoryView>
    <MidCourseReviewMeetingView
      v-else-if="activity === 'MID_COURSE_REVIEWS'"
    ></MidCourseReviewMeetingView>
    <ContributionDistrictFundView
      v-else-if="activity === 'CONTRIBUTION_DISTRICT_FUNDS'"
    ></ContributionDistrictFundView>

    <ParticipationDistrictFundView
      v-else-if="activity === 'PARTICIPATION_AT_DISTRICT_FUNDS'"
    ></ParticipationDistrictFundView>

    <ViceGovernorVisitView
      v-else-if="activity === 'VICE_GOVERNOR_VISITS'"
    ></ViceGovernorVisitView>

    <MjfNightView v-else-if="activity === 'MJF_NIGHTS'"></MjfNightView>

    <DuesSecondHalfView
      v-else-if="activity === 'DUES_FOR_SECOND_HALVES'"
    ></DuesSecondHalfView>
    <HonoringPastDistrictView
      v-else-if="activity === 'HONORING_OF_PAST_DISTRICTS'"
    >
    </HonoringPastDistrictView>

    <NominationCommitteeView
      v-else-if="activity === 'NOMINATION_COMMITTEES'"
    ></NominationCommitteeView>

    <NominationElectionCommitteeView
      v-else-if="activity === 'NOMINATION_ELECTIONS'"
    ></NominationElectionCommitteeView>
    <DistrictConventionView
      v-else-if="activity === 'REGISTERED_FOR_CONVENTIONS'"
    ></DistrictConventionView>

    <SubmissionPuView
      v-else-if="activity === 'SUBMISSION_OF_PUS'"
    ></SubmissionPuView>
    <ClubFundRasingView
      v-else-if="activity === 'CLUB_FUNDS_RASING'"
    ></ClubFundRasingView>

    <ParticipationDistrictEventsView
      v-else-if="activity === 'PARTICIPATION_DISTRICT_EVENTS'"
    ></ParticipationDistrictEventsView>

    <ContributionDistrictEventView
      v-else-if="activity === 'CONTRIBUTION_TO_DISTRICT_EVENTS'"
    ></ContributionDistrictEventView>

    <ContributionDistrictSignatureProjectView
      v-else-if="activity === 'CONTRIBUTION_TO_DISTRICT_SIGNATURE_PROJECT'"
    ></ContributionDistrictSignatureProjectView>

    

    <ActivityEstimationPoints></ActivityEstimationPoints>
    <ActivityPointsAdjustment></ActivityPointsAdjustment>
    <ApproveActivity></ApproveActivity>

  </div>
</template>

<script>
import BoardMeetingView from "@/components/activities/view/BoardMeetingView";
import MonthlyMeetingView from "@/components/activities/view/MonthlyMeetingView";
import MonthlyMembershipsView from "@/components/activities/view/MonthlyMembershipsView";
import PublishNewLatterView from "@/components/activities/view/PublishNewLatterView";
import FinancialStatementView from "@/components/activities/view/FinancialStatementView";
import FacebookView from "@/components/activities/view/FacebookView";
import WebsiteView from "@/components/activities/view/WebsiteView";
import TrainingsView from "@/components/activities/view/TrainingsView";
import ExtensionNewLionsClubView from "@/components/activities/view/ExtensionNewLionsClubView";
import ExtensionNewLeoClubView from "@/components/activities/view/ExtensionNewLeoClubView";
import PresidentExcellenceAwardsView from "@/components/activities/view/PresidentExcellenceAwardsView";
import LeadersInClubVicinitiesView from "@/components/activities/view/LeadersInClubVicinitiesView";
import NewClubOfficerWorkshopsView from "@/components/activities/view/NewClubOfficerWorkshopsView";
import MafContributionView from "@/components/activities/view/MafContributionView";
import MjfContributionView from "@/components/activities/view/MjfContributionView";
import CabinetInstallationCeremonyView from "@/components/activities/view/CabinetInstallationCeremonyView";
import AppointmentBoardClubAuditorView from "@/components/activities/view/AppointmentBoardClubAuditorView";
import HonoringPastPresidentView from "@/components/activities/view/HonoringPastPresidentView";
import HandingOverClubRecordView from "@/components/activities/view/HandingOverClubRecordView";

import DistrictDueView from "@/components/activities/view/DistrictDueView";
import PaymentDistrictDirectoryView from "@/components/activities/view/PaymentDistrictDirectoryView";
import PublishingClubDirectoryView from "@/components/activities/view/PublishingClubDirectoryView";
import RecognitionLionLadyView from "@/components/activities/view/RecognitionLionLadyView";
import LadiesGetTogetherView from "@/components/activities/view/LadiesGetTogetherView";
import FirstZonalAdvisoryView from "@/components/activities/view/FirstZonalAdvisoryView";
import RegionActionMeetingView from "@/components/activities/view/RegionActionMeetingView";
import AuditedAccountView from "@/components/activities/view/AuditedAccountView";
import GetDateCharterView from "@/components/activities/view/GetDateCharterView";
import InternationalDueView from "@/components/activities/view/InternationalDueView";
import DistrictGetTogetherView from "@/components/activities/view/DistrictGetTogetherView";
import ZoneChairpersonVisitView from "@/components/activities/view/ZoneChairpersonVisitView";
import ReportCepWorkshopView from "@/components/activities/view/ReportCepWorkshopView";
import RegionChairpersonVisitView from "@/components/activities/view/RegionChairpersonVisitView";
import MemberSponsorNightView from "@/components/activities/view/MemberSponsorNightView";
import ActivityEstimationPoints from "@/components/activities/view/child/ActivityEstimationPoints";
import ApproveActivity from "@/components/activities/view/child/ApproveActivity";
import SecondZonalAdvisoryView from "@/components/activities/view/SecondZonalAdvisoryView";
import ThirdZonalAdvisoryView from "@/components/activities/view/ThirdZonalAdvisoryView";
import MidCourseReviewMeetingView from "@/components/activities/view/MidCourseReviewMeetingView";
import ContributionDistrictFundView from "@/components/activities/view/ContributionDistrictFundView";
import ParticipationDistrictFundView from "@/components/activities/view/ParticipationDistrictFundView";
import ViceGovernorVisitView from "@/components/activities/view/ViceGovernorVisitView";
import MjfNightView from "@/components/activities/view/MjfNightView";
import DuesSecondHalfView from "@/components/activities/view/DuesSecondHalfView";
import HonoringPastDistrictView from "@/components/activities/view/HonoringPastDistrictView";
import NominationCommitteeView from "@/components/activities/view/NominationCommitteeView";
import NominationElectionCommitteeView from "@/components/activities/view/NominationElectionCommitteeView";
import DistrictConventionView from "@/components/activities/view/DistrictConventionView";
import SubmissionPuView from "@/components/activities/view/SubmissionPuView";
import ClubFundRasingView from "@/components/activities/view/ClubFundRasingView";
import ParticipationDistrictEventsView from "@/components/activities/view/ParticipationDistrictEventsView";
import ContributionDistrictEventView from "@/components/activities/view/ContributionDistrictEventView";
import ContributionDistrictSignatureProjectView from "@/components/activities/view/ContributionDistrictSignatureProjectView";
import ActivityPointsAdjustment from "@/components/activities/view/child/ActivityPointsAdjustment";

export default {
  name: "groupSetUpFrom",

  components: {
    BoardMeetingView,
    MonthlyMeetingView,
    MonthlyMembershipsView,
    PublishNewLatterView,
    FinancialStatementView,
    FacebookView,
    WebsiteView,
    TrainingsView,
    ExtensionNewLionsClubView,
    ExtensionNewLeoClubView,
    PresidentExcellenceAwardsView,
    LeadersInClubVicinitiesView,
    NewClubOfficerWorkshopsView,
    MafContributionView,
    MjfContributionView,
    CabinetInstallationCeremonyView,
    AppointmentBoardClubAuditorView,
    HonoringPastPresidentView,
    HandingOverClubRecordView,
    DistrictDueView,
    PaymentDistrictDirectoryView,
    PublishingClubDirectoryView,
    RecognitionLionLadyView,
    LadiesGetTogetherView,
    FirstZonalAdvisoryView,
    RegionActionMeetingView,
    AuditedAccountView,
    GetDateCharterView,
    InternationalDueView,
    DistrictGetTogetherView,
    ZoneChairpersonVisitView,
    ReportCepWorkshopView,
    RegionChairpersonVisitView,
    MemberSponsorNightView,
    ActivityEstimationPoints,
    ApproveActivity,
    SecondZonalAdvisoryView,
    ThirdZonalAdvisoryView,
    MidCourseReviewMeetingView,
    ContributionDistrictFundView,
    ParticipationDistrictFundView,
    ViceGovernorVisitView,
    MjfNightView,
    DuesSecondHalfView,
    HonoringPastDistrictView,
    NominationCommitteeView,
    NominationElectionCommitteeView,
    DistrictConventionView,
    SubmissionPuView,
    ClubFundRasingView,
    ParticipationDistrictEventsView,
    ContributionDistrictEventView,
    ContributionDistrictSignatureProjectView,
    ActivityPointsAdjustment,
  },

  data: () => ({
    loading: false,
    errors: null,
    snackbar: false,
    activity: null,
    successMsg: "",
    form: {
      role: localStorage.getItem("role"),
    },
  }),

  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.activity = this.$route.params.key;
  },

  methods: {},
};
</script>
